import React from 'react'
import ListLazeCuttingPage from './ListLazeCuttingPage'
import '../styles/index.scss'

function ListLazePageContainer() {
  return (
    <div className="ListLazePageContainer py-5">
        <ListLazeCuttingPage/>
    </div>
  )
}

export default ListLazePageContainer